"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var react_router_dom_1 = require("react-router-dom");
var Tile_1 = __importDefault(require("@/frontend/react/components/Tile"));
var ArrowForward_1 = __importDefault(require("@mui/icons-material/ArrowForward"));
var trans_1 = __importDefault(require("@/plugins/trans"));
var StringMaxLength_1 = __importDefault(require("@/frontend/StringMaxLength"));
var NotificationContext_1 = __importDefault(require("../../context/NotificationContext"));
var CurrentConnectionContext_1 = __importDefault(require("../../context/CurrentConnectionContext"));
var navLinkCss = function (theme) { return ({
    textDecoration: 'none',
    color: theme.palette.text.primary,
}); };
function ChatTile(_a) {
    var connection = _a.connection;
    var notifications = (0, react_1.useContext)(NotificationContext_1.default).notifications;
    var setCurrentConnection = (0, react_1.useContext)(CurrentConnectionContext_1.default).setCurrentConnection;
    var hasNotification = typeof notifications.conversations[connection.conversationId] !== 'undefined';
    var chatParam = (0, react_router_dom_1.useParams)().chatId;
    (0, react_1.useEffect)(function () {
        if (!chatParam) {
            return;
        }
        if (connection.conversationId.toString() === chatParam) {
            setCurrentConnection(connection);
        }
    }, [chatParam, connection]);
    return ((0, jsx_runtime_1.jsx)(react_router_dom_1.NavLink, __assign({ to: "".concat(connection.conversationId), css: navLinkCss }, { children: function (_a) {
            var isActive = _a.isActive;
            return ((0, jsx_runtime_1.jsx)(Tile_1.default, __assign({ active: isActive }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", gap: 4, mt: 4 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, { children: (0, jsx_runtime_1.jsx)(material_1.Avatar, { src: connection.profile.profilePicture, alt: connection.name }) }), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ flexBasis: "60%" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ fontWeight: "bold", color: "primary" }, { children: connection.name })), (0, jsx_runtime_1.jsx)(StringMaxLength_1.default, { string: connection.profile.tagline, maxLength: 32 }), hasNotification && ((0, jsx_runtime_1.jsxs)(material_1.Typography, __assign({ display: "flex", fontWeight: "bold", gap: 2, mt: 2 }, { children: [trans_1.default.transChoice('strings.frontend.new_messages_amount', notifications.conversations[connection.conversationId], {
                                            amount: notifications.conversations[connection.conversationId].toString(),
                                        }), (0, jsx_runtime_1.jsx)(ArrowForward_1.default, { color: "primary" })] })))] })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ flexGrow: 1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ fontWeight: "bold" }, { children: connection.lastMessageDate })) }))] })) })));
        } })));
}
exports.default = ChatTile;
